
import Vue from 'vue';
import Router from 'vue-router';
import OTPVerifcation from './views/OTPVerifcation.vue';
import AgreementSignature from './views/AgreementSignature.vue';
import TempSignature from "@/views/TempSignature";
import axios from 'axios';

Vue.use(Router);

axios.defaults.headers.common['Authorization'] = 'Basic ' + process.env.VUE_APP_CLIENT_API_TOKEN;
export default new Router({
  mode: 'history', 
  routes: [
    { path: '/', component: OTPVerifcation, name: 'Verification' },
    { path: '/agreement-signature', component: AgreementSignature },
    {
      path: '/temp-pending-sign/:policyID',
      name: 'Signature',
      component: TempSignature,
    },
  ],
});